import { useAuthenticateWithWallet } from "./useAuthenticateWithWallet";
function useSignUpWithWallet(mutationOptions = {}) {
    const { authenticateWithWallet, authenticateWithWalletAsync, ...rest } = useAuthenticateWithWallet(true, mutationOptions);
    return {
        signUpWithWallet: authenticateWithWallet,
        signUpWithWalletAsync: authenticateWithWalletAsync,
        ...rest,
    };
}
export { useSignUpWithWallet };
//# sourceMappingURL=useSignUpWithWallet.js.map